import { useEffect, useState } from "react";

function AnimatedGradientCards({ cardsData }) {
  // Reverted back to the original bright gradients
  const defaultCards = [
    {
      title: "Ad space",
      gradient: "linear-gradient(135deg,#FF00FF 0%, #FF00AA 50%, #FF0008 100%)",
    },
    {
      title: "Ad space",
      gradient: "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)",
    },
    {
      title: "zeusdb",
      gradient: "linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)",
    },
    {
      title: "TempleGrid",
      gradient: "linear-gradient(135deg, #ffe259 0%, #ffa751 100%)",
    },
  ];

  const cards = cardsData || defaultCards;

  const [explodeIndex, setExplodeIndex] = useState(-1);

  useEffect(() => {
    const explodeInterval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * cards.length);
      setExplodeIndex(randomIndex);
      setTimeout(() => setExplodeIndex(-1), 2000);
    }, 2450);

    return () => clearInterval(explodeInterval);
  }, [cards.length]);

  const renderTrack = (trackNumber) => (
    <div className={`marquee-track track-${trackNumber}`}>
      {[...cards, ...cards].map((card, index) => (
        <div
          key={index}
          className={`card ${
            index % cards.length === explodeIndex ? "explode-active" : ""
          }`}
          style={{ background: card.gradient }}
        >
          <div className="card-content">
            <h2>{card.title}</h2>
            {card.desc && <p>{card.desc}</p>}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="page-container">
      <div className="cards-container full-width">
        {renderTrack(1)}
        {renderTrack(2)}
        {renderTrack(3)}
      </div>
    </div>
  );
}

export default AnimatedGradientCards;
